import type { FirebaseOptions } from "firebase/app";

interface BaseConfigOptions {
    trainingsUrl?: string;
    bugsnagPublicApiKey?: string;
    firebaseConfig: FirebaseOptions;
    jobPositionEmailRecipientLimit: number;
    enableNpsModal?: boolean;
    applicantMangerExcludedCustomerIds?: number[];
    googleMapsClientApiKey?: string;
    defaultApplicantManagerFirebaseUids?: string[];
    muxEnvKey?: string;
    enableCourses?: boolean;
}

class BaseConfig {
    trainingsUrl: string;
    bugsnagPublicApiKey: string;
    firebaseConfig: FirebaseOptions;
    jobPositionEmailRecipientLimit: number;
    enableNpsModal?: boolean;
    applicantMangerExcludedCustomerIds?: number[];
    googleMapsClientApiKey: string;
    defaultApplicantManagerFirebaseUids?: string[];
    muxEnvKey: string;
    enableCourses: boolean;

    constructor({
        trainingsUrl = "https://stahlhart-recruiting.mymemberspot.de/library",
        bugsnagPublicApiKey = "e4b31bf8afbacd7b8e316174871c0875",
        firebaseConfig,
        jobPositionEmailRecipientLimit = 5,
        enableNpsModal = false,
        applicantMangerExcludedCustomerIds = [],
        googleMapsClientApiKey = "AIzaSyCpjJTRjYu6zUxWx6AyaaMOwiuJ9IBPW28",
        defaultApplicantManagerFirebaseUids = [],
        /**
         * @deprecated The courses feature is deprecated for now. The Mux account is going to be deleted.
         */
        muxEnvKey = "10ksbgqj30cnk7kmgom7jj3nu",
        enableCourses = false,
    }: BaseConfigOptions) {
        this.trainingsUrl = trainingsUrl;
        this.bugsnagPublicApiKey = bugsnagPublicApiKey;
        this.firebaseConfig = firebaseConfig;
        this.jobPositionEmailRecipientLimit = jobPositionEmailRecipientLimit;
        this.enableNpsModal = enableNpsModal;
        this.applicantMangerExcludedCustomerIds =
            applicantMangerExcludedCustomerIds;
        this.googleMapsClientApiKey = googleMapsClientApiKey;
        this.defaultApplicantManagerFirebaseUids =
            defaultApplicantManagerFirebaseUids;
        this.muxEnvKey = muxEnvKey;
        this.enableCourses = enableCourses;
    }
}

export { BaseConfig };
